<template>
  <img v-if="photo" :src="imagePath(rawValue(photo, 'itg_urlimagem'))" :alt="alt" loading="lazy" />
</template>
<script>
import { imagesFor, imagePath, rawValue, plainText, contentValue } from '@/services/contentApi';
export default {
  name: 'RecordImage',
  props: { item: Object, screen: Object },
  computed: {
    photo() {
      return imagesFor(this.item, this.screen)[0];
    },
    alt() {
      return plainText(
        rawValue(this.photo, 'itg_alt') ||
          rawValue(this.photo, 'itg_nome') ||
          contentValue(this.item, 'iti_nome'),
      );
    },
  },
  methods: { imagePath, rawValue },
};
</script>
